import React, { useState, useEffect } from "react";
import { Stack, Button, DialogContent, Dialog, Box } from "@mui/material";
import { FormControlLabel, Radio, Autocomplete } from "@mui/material";
import { FormControl, RadioGroup, TextField, Typography } from "@mui/material";
import { saveLedger } from "./httpCalls";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { clearLedgers, getLedgers } from "./ledgerSlice";
import addIcon from "../../images/add.svg";
import DialogComponent from "../reusableComponents/Dialog";
import { updateCompany } from "../company profile/httpCalls";
import { Toast } from "../components/Toast";
import { addRegion, getCompany } from "../company profile/companySlice";
import { BtnCancel, ButtonAdd } from "../styles";
import add from "../../images/add.svg";
import Loader from "../components/Loader";
import { clearLedgersNames } from "./ledgersNamesSlice";

function AddLedger() {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.ledger);
  const { company } = useSelector((state) => state.company);
  const {status } = useSelector((state) => state.trial);

  let companyCode = localStorage.getItem("companyCode");
  const [state, setState] = useState({
    loading: false,
    name: "",
    address: "",
    ledgerType: "customer",
    region: "",
    title: "",
    addModal: false,
    modal: false,
  });

  useEffect(() => {
    if (company == "") {
      dispatch(getCompany());
    }
  }, []);

  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleSubmit = async () => {
    if (state.name == "") {
      Toast("info", "Kindly provide ledger name");
      return;
    }
    setState((prev) => ({ ...prev, loading: true }));
    let _id = uuidv4();
    let id = _id.replaceAll("-", "");
    let new_ledger = {
      _id: id,
      name: state.name,
      ledgerType: state.ledgerType,
      address: state.address,
      region: state.region,
      companyCode: companyCode,
    };

    await saveLedger(new_ledger, dispatch,status);
    setState((prev) => ({ ...prev, loading: false, modal: false }));
    const tokenType = localStorage.getItem("tokenType");
    let regions = tokenType == "admin" ? [] : company?.ledgerRegions;
    let obj = {
      ledgerRegions: regions,
      next_page_token: "",
    };
    dispatch(clearLedgers());
    dispatch(clearLedgersNames());
    dispatch(getLedgers(obj));
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const searchRegions = () => {
    if (company?.ledgerRegions) {
      return company.ledgerRegions;
    } else {
      return [];
    }
  };

  const handleRegion = (e, val) => {
    setState((prev) => ({ ...prev, region: val }));
  };

  const submitRegion = async () => {
    if (state.title == "") {
      Toast("info", "Add Region Title");
      return;
    }
    let copy = JSON.parse(JSON.stringify(company));
    if (copy?.ledgerRegions) {
      let regions = copy.ledgerRegions;
      copy.ledgerRegions = [state.title, ...regions];
    } else {
      copy.ledgerRegions = [];
      copy.ledgerRegions = [state.title];
    }
    setState((prev) => ({ ...prev, title: "", addModal: false }));
    dispatch(addRegion(copy));
    updateCompany(copy, dispatch);
  };

  return (
    <Box>
      <ButtonAdd
        variant="contained"
        sx={{ width: { md: "100%", xs: "80%" } }}
        onClick={() => toggle("modal")}
      >
        Add <img src={add} alt="add" />
      </ButtonAdd>
      <DialogComponent
        title="Add Ledger"
        open={state.modal}
        onClose={() => toggle("modal")}
        onClickCancel={() => toggle("modal")}
        dialogContent={
          <Stack direction="column" spacing={2}>
            <Typography variant="h6" sx={{ color: "#4eaf51" }}>
              Add New Ledger
            </Typography>
            <TextField
              autoFocus
              size="small"
              label="Ledger Name"
              fullWidth
              name="name"
              value={state.name}
              onChange={handleChange}
            />
            <TextField
              size="small"
              label="Address"
              type="text"
              name="address"
              fullWidth
              value={state.address}
              onChange={handleChange}
            />
            <Stack direction="row" justifyContent="space-between">
              <Autocomplete
                size="small"
                onChange={(e, val) => {
                  handleRegion(e, val);
                }}
                getOptionLabel={(option) => option || ""}
                id="controllable-states-demo"
                options={searchRegions()}
                sx={{ width: "90%" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Region"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                )}
              />
              <img
                style={{ cursor: "pointer" }}
                src={addIcon}
                alt=""
                onClick={() => toggle("addModal")}
              />
            </Stack>

            <FormControl component="fieldset">
              <RadioGroup
                row
                name="ledgerType"
                style={{ display: "flex", justifyContent: "center" }}
                value={state.ledgerType}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="customer"
                  control={<Radio />}
                  label="Customer"
                />
                <FormControlLabel
                  value="supplier"
                  control={<Radio />}
                  label="Supplier"
                />
              </RadioGroup>
            </FormControl>

            {state.loading ? (
              <Loader loading={state.loading} />
            ) : (
              <Stack direction="row" justifyContent="center" spacing={3}>
                <Button variant="contained" onClick={handleSubmit}>
                  Add Ledger
                </Button>
                <BtnCancel onClick={() => toggle("modal")}>Cancel</BtnCancel>
              </Stack>
            )}
            <Dialog
              title="Add Region"
              open={state.addModal}
              onClose={() => toggle("addModal")}
              maxWidth="sm"
            >
              <DialogContent>
                <Stack direction="column" spacing={2}>
                  <Typography
                    variant="h6"
                    sx={{ textAlign: "center", color: "#4eaf51" }}
                  >
                    Add New Region
                  </Typography>
                  <TextField
                    autoFocus
                    size="small"
                    label="Region Title"
                    fullWidth
                    name="title"
                    value={state.title}
                    onChange={handleChange}
                  />

                  <Stack direction="row" justifyContent="center" spacing={3}>
                    <Button variant="contained" onClick={submitRegion}>
                      Add
                    </Button>
                    <BtnCancel onClick={() => toggle("addModal")}>
                      Cancel
                    </BtnCancel>
                  </Stack>
                </Stack>
              </DialogContent>
            </Dialog>
          </Stack>
        }
      />
    </Box>
  );
}

export default AddLedger;
